module.exports = __webpack_public_path__ + "static/img/active6.1885537d.png";